export const UserMutationError = {
	USER_ALREADY_EXISTS: "USER_ALREADY_EXISTS",
	UNEXPECTED_ERROR: "UNEXPECTED_ERROR",
} as const;
